export default function About() {
  return (
    <section id="about" className="bg-[#0C0C0C] py-24 md:py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF3333]" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">04 — Our Story</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-6xl tracking-tighter leading-[0.9] mb-8">
            More than <span className="italic text-[#FF3333]">cuts</span>.<br />
            It's a <span className="italic">culture</span>.
          </h2>
          <div className="space-y-5 text-white/70 font-light leading-relaxed text-lg">
            <p>
              McNeal Cutz is founded on one rule: every person who sits in our chair walks out
              sharper than they walked in. Period.
            </p>
            <p>
              Run by <span className="text-white font-medium">Tim McNeal</span> — barber, founder,
              and the man behind every fade — the shop is a Monroe staple where craft meets
              culture. Sharp clippers, sharper conversation, no compromises.
            </p>
            <p>
              <span className="text-white font-medium">Book online 24/7. Walk out with confidence.</span>
            </p>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
            <div>
              <div className="font-display text-3xl font-black text-[#FF3333]">1</div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/50 mt-1">Master barber</div>
            </div>
            <div>
              <div className="font-display text-3xl font-black text-[#FF3333]">9</div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/50 mt-1">Services</div>
            </div>
            <div>
              <div className="font-display text-3xl font-black text-[#FF3333]">∞</div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/50 mt-1">Fresh cuts</div>
            </div>
          </div>
        </div>

        <div className="md:col-span-6 order-1 md:order-2 relative">
          <div className="aspect-[4/5] overflow-hidden">
            <img
              src="https://d2zdpiztbgorvt.cloudfront.net/region1/us/1700730/biz_photo/1e1077e1898d47a49d43825bcc6067-mcnealcutz-biz-photo-a105d12c53d24c92a79f4b198342ed-booksy.jpeg?size=640x427"
              alt="McNeal Cutz shop"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 md:-left-12 bg-[#FF3333] text-black px-6 py-4 max-w-xs">
            <div className="font-display font-black text-2xl uppercase leading-tight">McNeal Cutz</div>
            <div className="text-xs uppercase tracking-[0.2em] mt-1">2006 Prairie Rd • Monroe, LA</div>
          </div>
        </div>
      </div>
    </section>
  );
}
